import { c as _c } from "react/compiler-runtime";
import { FC, HTMLProps } from "react";

/**
 * A hidden input field to prevent bots from submitting forms.
 */
export const BotInput: FC<HTMLProps<HTMLInputElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "none"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <input {...props} data-testid="honeypot" style={t0} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BotInput;